import { constants } from "@newsela/angelou";
const greyExtraLight = constants.colors.ui.neutral[25];

const ERROR_PAGE_CONTENTS_MAX_WIDTH = 500;

export const errorPageCss = {
  backgroundColor: greyExtraLight,
  "> *": {
    maxWidth: ERROR_PAGE_CONTENTS_MAX_WIDTH,
  },
};
